<template>
  <div class="sidebar">
    <Workspaces />
    <SideMain />
  </div>
</template>

<script>
import Workspaces from './Workspaces';
import SideMain from './SideMain';
export default {
  name: 'Dashboard',
  components: { Workspaces, SideMain },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
